export const BANNER = {
  imageUrl: "https://cdn.staticsfly.com/i/signup_confirmation/Hero.png",
  heading: "Welcome to the Shutterfly family!",
  subHeading:
    "Just add your photos and enjoy 101 free prints, 5 free magnets, 1 free set of address labels and 1 free art print*",
  note: "Offer automatically applied at checkout",
  buttonText: "UPLOAD YOUR PHOTOS",
  buttonLink: "https://photos.dev.shutterfly.com/add"
};

export const PRODUCT_CARDS = {
  heading: "Let us help you get started with your first product",
  subHeading: "Here are some of our favorites",
  products: [
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Photo_Books.png?impolicy=resize&width=300",
      imageAltText: "PHOTO BOOKS",
      heding: "PHOTO BOOKS",
      description:
        "Relive your fondest memories with a personalized photo book",
      linkText: "Shop Now >",
      linkUrl: "/photo-books"
    },
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Gifts.png?impolicy=resize&width=300",
      imageAltText: "GIFTS ",
      heding: "GIFTS",
      description:
        "Turn your photos into unique gifts that are fun to give and to keep",
      linkText: "Shop Now >",
      linkUrl: "/personalized-gifts"
    },
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Prints.png?impolicy=resize&width=300",
      imageAltText: "Product Image",
      heding: "PRINTS",
      description:
        "Remember moments big and small with professional prints in variety of sizes",
      linkText: "Shop Now >",
      linkUrl: "/prints/prints"
    },
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Magnets.png?impolicy=resize&width=300",
      imageAltText: "MAGNETS",
      heding: "MAGNETS",
      description:
        "Add joy to your refrigerator, file cabinets and more with our photo magnets",
      linkText: "Shop Now >",
      linkUrl: "/photo-gifts/magnet+photo--magnets"
    },
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Address_Labels.png?impolicy=resize&width=300",
      imageAltText: "ADDRESS LABELS",
      heding: "ADDRESS LABELS",
      description: "Address your envelopes with stylish address label",
      linkText: "Shop Now >",
      linkUrl: "/cards-stationery/address-labels"
    },
    {
      imageUrl:
        "https://cdn.staticsfly.com/i/signup_confirmation/Art_Prints.png?impolicy=resize&width=300",
      imageAltText: "Product Image",
      heding: "ART PRINTS",
      description:
        "Spruce up your space with a gallery-quality premium cardstock art print",
      linkText: "Shop Now >",
      linkUrl: "/prints/prints-posters/art-prints"
    }
  ]
};

export const SCR_FOOTER = {
  heding: "Enjoy unlimited free storage 11",
  subHeading: "All your photos. All in one place. For free",
  desktop: {
    imageUrl: "https://cdn.staticsfly.com/i/signup_confirmation/Desktop.png",
    imageAltText: "Desktop View Image...",
    heding: "DESKTOP",
    subHeading: "Upload as many photos as you like in just a few clicks",
    linkUrl: "#"
  },
  mobile: {
    imageUrl:
      "https://cdn.staticsfly.com/i/signup_confirmation/Mobile_Phone.png",
    imageAltText: "Desktop View Image...",
    heding: "Shutterfly APP",
    subHeading: "Easily upload photos from your phone with our app",
    linkUrl: "#"
  },
  disclaimer:
    "*Offers expire 30 calendar days from the time of registration (11:59 P.M. PT). Offer is good for 101 free glossy/matte prints (4x4 or 4x6 prints), five free non-Disney photo magnets, one free set of address labels and one non-framed, non-metallic 8x10 art print on signature cardstock through shutterfly.com, our mobile-friendly site or the Shutterfly app (only select products are available on the app). Offer is valid on all magnet sizes (only select sizes are available on the app), but limited to one magnet size and type per order. Valid only on your first purchase from Shutterfly. Offers cannot be redeemed more than once per account and/or billing address. Taxes, shipping and handling may apply. Not valid on other print sizes/finish, Disney styles, glass, stationery and wood magnets, metallic, framed and other art print sizes/finish, Tiny Prints products, prepaid plans, other products, prior purchases and orders placed for in-store pick up. Valid for the intended recipient only. Offers are subject to product availability and cannot be redeemed for cash or combined with other offers or credits. Not valid for resale. We reserve the right to modify or replace any part of these terms and conditions without notice. \n \n Shutterfly uses industry-standard SSL software to encrypt your personal information, including password and credit card number, so that it cannot be read over the internet. For your convenience we keep you signed in until you sign out."
};
